// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ServicesList_wrapper__2BD9D","groupTitle":"_ServicesList_groupTitle__1klpx","debt":"_ServicesList_debt__2nkCJ"};